import { ExtendsMainComponent } from '../extends/extends-main.component';

import { ViewChild } from '@angular/core';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { MfaTelephoneComponent } from './mfa-telephone.component';
import { CheckItemService, CheckItemIn } from '../../service/checkItem.service';

import { TokenManager } from '../../service/web-api.service';

import { AuthService } from '../../service/auth.service';
import { MfaTelephoneService } from '../../service/mfa-telephone.service';
import { environment } from '../../../environments/environment';
import { SelectMultipleControlValueAccessor } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/fromEvent';

declare let gtag: any; // グローバル変数gtagを解決

export class MfaTelephoneMainComponent extends ExtendsMainComponent {
  private confirmModal: ConfirmModalComponent;
  private waitModal: WaitModalComponent;
  private mfaTelephoneComponent: MfaTelephoneComponent;

  private authService: AuthService;

  private mfaTelephoneService: MfaTelephoneService;

  private checkItemService: CheckItemService;

  private timer: Subscription;

  private checkItemIn: CheckItemIn;

  // 画面項目定義
  public phoneNumber: string;
  public messages: any;
  public smartInTelephoneNumber: string;

  public normalDisplay: string;
  public errDisplay: string;

  // 画面ID
  readonly SCREEN_ID = 'O09';

  /** リソース表示名(複数) */
  public displayResourceNames: string[];

  init(_mfaTelephoneComponent: MfaTelephoneComponent, _authService: AuthService, _checkItemService: CheckItemService,
    _waitModal: WaitModalComponent, _confirmModal: ConfirmModalComponent, _mfaTelephoneService: MfaTelephoneService) {

    this.config();
    this.mfaTelephoneService = _mfaTelephoneService;
    this.mfaTelephoneComponent = _mfaTelephoneComponent;
    this.checkItemService = _checkItemService;
    this.authService = _authService;
    this.waitModal = _waitModal;
    this.confirmModal = _confirmModal;
    this.smartInTelephoneNumber = environment.smartInTelephoneNumber;
    this.phoneNumber = this.mfaTelephoneComponent.phoneNumber;

    this.normalDisplay = '';
    this.errDisplay = 'none';

    // 画面切り替え時に電話認証をする場合の処理
    if (this.mfaTelephoneComponent.isMfaPage) {
      this.execMfaPhone();
      this.mfaTelephoneComponent.isMfaPage = false;
    }
  }

  /**
   * 次へ
   *
   * @param checkItem チェック対象項目
   * @param isRequiredArray 必須チェック対象項目
   * @param isMfaPage 次画面で電話認証をする場合true
   * @param hasCompletePage 電話認証完了画面が存在する場合true
   */
  next(checkItem: string[], isRequiredArray?: string[], isMfaPage?: boolean, hasCompletePage?: boolean) {
    // パラメータ設定
    this.checkItemIn = new CheckItemIn();
    for (const item of checkItem) {
      switch (item) {
        case 'phoneNumber':
          this.checkItemIn.phoneNumber = this.phoneNumber;
          break;
      }
    }
    this.waitModal.showModal();

    // チェック処理
    this.checkItemService.execAuthCheckItem(this.checkItemIn, isRequiredArray).subscribe(result => {
      this.waitModal.hideModal();

      if (result == null) {
        this.messages = [];

        // 引継ぎ項目
        this.mfaTelephoneComponent.pageNo++;
        this.mfaTelephoneComponent.phoneNumber = this.phoneNumber;

        // 次画面で電話認証をする場合
        if (isMfaPage) {
          // 画面切り替え時に電話認証リクエストを送信するフラグをtrueにする
          this.mfaTelephoneComponent.isMfaPage = true;
        }

        // 次画面が電話認証が完了する画面の場合
        if (hasCompletePage) {
          // 画面切り替え時に完了画面フラグをtrueにする
          this.mfaTelephoneComponent.hasCompletePage = true;
        }
        // 画面切り替え
        this.mfaTelephoneComponent.directInjection();

      } else {
        this.messages = result;
        this.scrollError();
      }
    });
  }

  /**
   * 同じ番号で再度電話認証する
   */
  reMfaPhone() {
    this.waitModal.showModal();

    // 表示する要素を切り替える
    this.messages = [];
    this.normalDisplay = '';
    this.errDisplay = 'none';

    this.waitModal.hideModal();
    this.execMfaPhone();
  }

  private execMfaPhone() {
    // 電話認証準備
    this.mfaTelephoneService.execMfaTelephonePre(this.phoneNumber).subscribe(resultPre => {
      if (resultPre == null) {
        this.messages = [];
        let errCount = 0;

        // 電話認証結果確認：結果のポーリング開始
        this.timer = Observable.interval(2000).subscribe(() => {
          this.mfaTelephoneService.execMfaTelephoneConfirm(this.SCREEN_ID).subscribe(
            resultConf => {
              if (resultConf.result) {
                switch (resultConf.code) {
                  case '00':
                    // 電話認証OKならばポーリングを停止
                    this.messages = [];
                    this.timer.unsubscribe();
                    // 電話認証完了画面が存在する場合は完了画面へ遷移
                    if (this.mfaTelephoneComponent.hasCompletePage) {
                      this.next([]);
                    } else {
                      // 電話認証完了画面がない場合はissue経由で次の画面へ遷移
                      if (this.authService.isV2) {
                        this.locationAssign('/oauth/v2/authorization/issue?' + TokenManager.getToken());
                      } else {
                        this.locationAssign('/oauth/authorization/issue?' + TokenManager.getToken());
                      }
                    }

                    return;
                  case '99':
                  // 電話待ち状態であればポーリング継続

                }
                //// タイムアウト時
              } else {
                // タイムアウトエラー画面で不要な要素を非表示とする
                this.normalDisplay = 'none';
                // タイムアウトエラー画面で必要な要素を表示する
                this.errDisplay = '';

                // ポーリングを停止しエラーメッセージ表示
                this.messages = resultConf.messages;
                this.timer.unsubscribe();
                this.scrollError('phone_confirm_error', this.messages);
                return;
              }
            },
            //// エラー時処理
            error => {
              if (error.status === 401) {
                // ポーリングを停止しエラー画面遷移
                this.timer.unsubscribe();
                this.mfaTelephoneComponent.router.navigate(['/error', error.status]);
                return;
              }
              if (error.status === 400) {
                if (errCount <= 2) {
                  // 400エラー発生3回までカウントし、エラーを無視する
                  errCount++;
                  return;
                }
                // ポーリングを停止しエラー画面遷移
                this.timer.unsubscribe();
                this.mfaTelephoneComponent.router.navigate(['/error', error.status]);
                return;
              }
            });
        });
      } else {
        this.messages = resultPre;
        // エラー画面で不要な要素を非表示とする
        this.normalDisplay = 'none';
        // エラー画面で必要な要素を表示する
        this.errDisplay = '';
        this.scrollError('phone_prerequest_error', this.messages);
        return;
      }
    });
  }

  /**
  * イベント：戻る
  */
  back() {
    // 引継ぎ項目
    this.mfaTelephoneComponent.pageNo--;

    // 画面切り替え
    this.mfaTelephoneComponent.directInjection();
    // timerオブジェクトがあるときはポーリングを停止させる
    if (this.timer) {
      this.timer.unsubscribe();
    }
  }

  /**
   * イベント：この端末から電話をかける
   */
  onClickTelephoneCall() {
    location.href = 'tel:' + this.smartInTelephoneNumber + '';
  }


  /**
    * イベント：電話番号認証完了
    */
  complete() {
    if (this.authService.isV2) {
      this.locationAssign('/oauth/v2/authorization/issue?' + TokenManager.getToken());
    } else {
      this.locationAssign('/oauth/authorization/issue?' + TokenManager.getToken());
    }
  }
}
